import { ToastProgrammatic as Toast } from 'buefy';

export default function toastConfirmation(message, type = 'is-success') {
  Toast.open({
    duration: 5000,
    message: message,
    position: 'is-top',
    type,
  });
}



// WEBPACK FOOTER //
// ./src/services/general/toastConfirmation.js